import { useState, useEffect, useCallback } from 'react'
import { eventBusService } from '../services/eventBusService'

export function useEventBus(options?: {
    initialResources?: { answer_ids?: string[]; quest_ids?: string[] }
}) {
    const [isConnected, setIsConnected] = useState(false)

    useEffect(() => {
        // Connect with initial resources if provided
        eventBusService.connect(options?.initialResources)

        // Set up connection state tracking
        const updateConnectionState = () => {
            const connected = eventBusService.isConnected()
            setIsConnected(connected)
        }

        eventBusService.onConnected(updateConnectionState)
        updateConnectionState()

        return () => {
            // Don't disconnect on unmount - service is singleton
        }
    }, [])

    const follow = useCallback((resourceType: 'answer' | 'quest' | 'user', resourceId: string) => {
        eventBusService.follow(resourceType, resourceId)
    }, [])

    const unfollow = useCallback(
        (resourceType: 'answer' | 'quest' | 'user', resourceId: string) => {
            eventBusService.unfollow(resourceType, resourceId)
        },
        [],
    )

    return {
        eventBus$: eventBusService.getEventBus$(),
        getTopic$: eventBusService.getTopic$.bind(eventBusService),
        getResourceTopic$: eventBusService.getResourceTopic$.bind(eventBusService),
        follow,
        unfollow,
        isSubscribedTo: eventBusService.isSubscribedTo.bind(eventBusService),
        isConnected,
    }
}
